export default __webpack_public_path__ + "static/media/Reversednav-logo.5ae47768.svg";